import Modal, { Sheets, ModalBody, ModalHeader } from '@ingka/modal';
import Text from '@ingka/text';
import Choice, { ChoiceItem } from '@ingka/choice';
import { useLocale } from '@lotta/self-service/lottery-fe/feature-hooks';
import { useNavigate } from 'react-router-dom';
import { useGetRetailUnitQuery } from '@lotta/self-service/lottery-fe/data-access-state';
import i18next from 'i18next';
import type { MouseEvent } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../ProfileSlider.module.scss';

export type LanguageSliderProps = {
  modalVisible: boolean;
  handleCloseBtn: (event: MouseEvent<HTMLButtonElement>) => void;
  handleBackBtn: (event: MouseEvent<HTMLButtonElement>) => void;
};

const LanguageChoices: React.FC = () => {
  const url = window.location.pathname;
  const { locale, retailUnit } = useLocale();
  const { data, isLoading, error } = useGetRetailUnitQuery({ retailUnit });
  const navigate = useNavigate();
  useEffect(() => {
    i18next.changeLanguage(locale);
  }, [locale]);
  const { t } = useTranslation();

  if (isLoading || error || !data) {
    return (
      <div className={styles['LocalizationDropdown']}>
        <Choice>
          <ChoiceItem disabled id="disabledChoice">
            {t('header-modal-language-change-language')}
          </ChoiceItem>
        </Choice>
      </div>
    );
  }
  const { languages } = data.retailUnit.selfService;
  return (
    <Choice
      size="medium"
      data-testid="languageSelect"
      onSelect={(language: string | null) => {
        if (language && languages.includes(language)) {
          const urlPrefix = url.split('/')[1];
          const urlSuffix = url.split('/').slice(3).join('/');
          const newPath = `/${urlPrefix}/${language}/${urlSuffix}`;
          navigate(newPath);
        }
      }}
    >
      {languages.map((language) => {
        return <ChoiceItem id={language} key={language} title={language.toUpperCase()} />;
      })}
    </Choice>
  );
};

export const LanguageSlider: React.FC<LanguageSliderProps> = (props) => {
  const { modalVisible, handleCloseBtn, handleBackBtn } = props;
  const { t } = useTranslation();

  return (
    <Modal visible={modalVisible} handleCloseBtn={handleCloseBtn}>
      <Sheets
        footer={null}
        header={
          <ModalHeader
            backBtnClick={handleBackBtn}
            title={`${t('header-modal-language-change-language')}`}
          />
        }
      >
        <ModalBody>
          <Text className={styles['LocalizationDropdown']}>
            {t('header-modal-language-select-language')}
          </Text>
          <LanguageChoices />
        </ModalBody>
      </Sheets>
    </Modal>
  );
};
